import {
  FINANCE_ALL,
  FINANCE_GET,
  FINANCE_PUT,
  FINANCE_POST,
  FINANCE_DEL,
  FINANCE_LOADING,
  FINANCE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const financeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: FINANCE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/finance`,
      {
        ...payload,
      },
    );
    dispatch({ type: FINANCE_POST, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: FINANCE_ERROR });
    throw new Error(error);
  }
};

export const financeAll = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/finance`,
    );

    if (status === 200) {
      dispatch({ type: FINANCE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: FINANCE_ERROR });
    throw new Error(error);
  }
};

export const financeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/finance/${id}`,
    );
    if (status === 200) {
      dispatch({ type: FINANCE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: FINANCE_ERROR });
    throw new Error(error);
  }
};

export const financePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: FINANCE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/finance/${id}`,
      payload,
    );
    dispatch({ type: FINANCE_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: FINANCE_ERROR });
    throw new Error(error);
  }
};

export const financeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: FINANCE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/finance/${id}`,
    );
    dispatch({ type: FINANCE_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: FINANCE_ERROR });
    throw new Error(error?.response?.data?.error?.message);
  }
};
